/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Field, ErrorMessage } from 'formik';
import moment from 'moment';
import DateTimePickerComponent from 'src/components/date-time-picker-component/DateTimePickerComponent';

const component = ({
    readOnly, disabled, field, form, ...rest
}) => (
    <>
        <DateTimePickerComponent
            disabled={readOnly || disabled}
            {...field}
            {...rest}
            onChange={(value, action) => {
                const date = moment(value).toDate();
                form.setFieldValue(field.name, date);
            }}
        />
        <ErrorMessage
            component="div"
            className="text-danger"
            name={field.name}
        />
    </>
);

component.propTypes = {
    field: PropTypes.any.isRequired,
    form: PropTypes.any.isRequired,
};

const FormikDateTimePicker = (props) => (
    <Field
        {...props}
        component={component}
    />
);

export default FormikDateTimePicker;
